// company-registration.component.ts
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Apollo } from 'apollo-angular';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/reducers';
import { NotificationService } from '../../../services/notification.service';
import { EMAIL_VALIDATOR } from '../../../shared/components/dynamic-forms-components/custom-validators';
import { createCitizenMutation } from '../../../store/entities/citizens/register/citizens/citizens.actions';
import {BRELA_VERIFICATION_MUTATION, CREATE_COMPANY_MUTATION} from "./verifyCompany.graphql";
import {passwordPolicyValidator, phoneNumbervalidator} from "../../../shared/validators/input-validators";

@Component({
  selector: 'app-company-registration',
  templateUrl: './company-registration.component.html',
  styleUrls: ['./company-registration.component.scss']
})
export class CompanyRegistrationComponent implements OnInit {
  form: FormGroup;
  hidePassword = true;
  hideConfirmPassword = true;
  brelaLoading = false;
  listOfDirectors: string[];
  brelaVerification: any;
  privacyPolicyText: string = `
    With my consent, I agree to the collection, use, and storage of my personal information in accordance with the
    <a href="/privacy-policy" target="_blank" class="underline text-primary-600">Privacy Policy</a>.
    Your information will be securely stored and used only for the stated purposes.
    You have the right to access and update your information at any time.
  `;

  constructor(
    private fb: FormBuilder,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group(
      {
        companyID: ['', Validators.required],
        phoneNumber: ['', [Validators.required,Validators.pattern(phoneNumbervalidator) ]],
        email: ['', [Validators.required, EMAIL_VALIDATOR.validator]],
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        consent: [false, Validators.requiredTrue]
      },
      { validator: this.matchPasswords('password', 'confirmPassword') }
    );
  }

  // verifyBrelaNumber() {
  //   const companyID = this.form.get('companyID')?.value;
  //   if (!companyID) return;
  //
  //   this.brelaLoading = true;
  //
  //   this.apollo.mutate({
  //     mutation: BRELA_VERIFICATION_MUTATION,
  //     variables: { regNumber: companyID },
  //     fetchPolicy: 'network-only'
  //   }).subscribe({
  //     next: ({ data }: any) => {
  //       this.brelaLoading = false;
  //       const result = data?.brelaVerificationMutation;
  //       this.brelaVerification = result.data;
  //       this.listOfDirectors = result.data?.listDirectors
  //       if (result?.response?.code === 9000 && result.data) {
  //         this.form.patchValue({
  //           companyName: result.data.companyName,
  //           shortForm: result.data.shortForm,
  //           country: result.data.country
  //         });
  //       } else {
  //         this.notificationService.errorMessage(result?.response?.message || 'Verification failed');
  //       }
  //     },
  //     error: (err) => {
  //       this.brelaLoading = false;
  //       this.notificationService.errorMessage('Network or server error during BRELA verification.');
  //       console.error(err);
  //     }
  //   });
  // }

  async submitForm() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const input = this.form.getRawValue();
     const formData = {
        representative: {
          phoneNumber:input.phoneNumber,
          email:input.email,
          lastName:input.lastName,
          firstName:input.firstName,
        },
        regNumber: input.companyID,
      };
      this.apollo.mutate({
        mutation: CREATE_COMPANY_MUTATION,
        variables: { input: formData },
        fetchPolicy: 'network-only'
      }).subscribe({
        next: ({ data }: any) => {
          const result = data?.createCompanyMutation;
          if (result?.response?.code === 9000 && result.data) {
            location.href = '/login';
          } else {
            this.notificationService.errorMessage(result?.response?.message || 'Sign up failed');
          }
        },
        error: (err) => {
          this.notificationService.errorMessage('Network or server error during Create Company Account.');
          console.error(err);
        }
      });

  }

  matchPasswords(passwordKey: string, confirmPasswordKey: string) {
    return (formGroup: FormGroup) => {
      const password = formGroup.get(passwordKey);
      const confirmPassword = formGroup.get(confirmPasswordKey);

      if (!password || !confirmPassword) return null;

      if (confirmPassword.errors && !confirmPassword.errors['passwordMismatch']) {
        return null;
      }

      if (password.value !== confirmPassword.value) {
        confirmPassword.setErrors({ passwordMismatch: true });
      } else {
        confirmPassword.setErrors(null);
      }
      return null;
    };
  }
}
